<template>
  <div>
    <CRow>
      <CCol md="12">

          <CCard id="printMe">
            <CCardHeader>
              <CRow>
                <CCol col="4" style="text-align: end">
                  <strong >{{$t('docNumber')}} : </strong>
                </CCol>
                <CCol col="8" style="text-align: start">

                  <strong >{{ doc_detail.docNo }}</strong>
                </CCol>
<!--                ********************88-->
                <CCol v-if="parseInt(doc_detail.amount)>=0" col="4" style="text-align: end">
                  <strong >{{$t('receiveCode')}} : </strong>
                </CCol>
                <CCol v-if="parseInt(doc_detail.amount)>=0" col="8" style="text-align: start">
                  <strong >{{ doc_detail.cashPaymentCode }}</strong>
                </CCol>
<!--                ********************88-->
                <!--                ********************88-->
                <CCol v-if="parseInt(doc_detail.amount)<0" col="4" style="text-align: end">
                  <strong >{{$t('payCode')}} : </strong>
                </CCol>
                <CCol v-if="parseInt(doc_detail.amount)<0" col="8" style="text-align: start">
                  <strong >{{ doc_detail.cashPaymentCode }}</strong>
                </CCol>
<!--                ********************88-->
                <CCol col="4" style="text-align: end">
                  <strong >{{ $t('components.date') }} : </strong>
                </CCol>
                <CCol col="8" style="text-align: start">

                  <strong >{{ get_date( doc_detail.docDate) }}</strong>
                </CCol>
<!--                ********************88-->
                <CCol col="4" style="text-align: end">
                  <strong >{{$t('cash')}} : </strong>
                </CCol>
                <CCol col="8" style="text-align: start">

                  <strong >{{ doc_detail.cashierName }}</strong>
                </CCol>
<!--                ********************88-->

                <CCol col="4" style="text-align: end">
                  <strong >{{$t('tables.payer')}} : </strong>
                </CCol>
                <CCol col="8" style="text-align: start">

                  <strong >{{ doc_detail.payerName }}</strong>
                </CCol>
<!--                ********************88-->

                <CCol col="4" style="text-align: end" >
                  <strong >{{$t('components.moenAccount')}} : </strong>
                </CCol>
                <CCol col="8" style="text-align: start">

                  <strong >{{doc_detail.partyAccountTitle}} {{doc_detail.partyCode}} {{ doc_detail.partyName }}</strong>
                </CCol>
<!--                ********************88-->

                <CCol col="4" style="text-align: end">
                  <strong >{{$t('components.amount')}} : </strong>
                </CCol>
                <CCol col="8" style="text-align: start">
                  <strong >{{get_currency(Math.abs(doc_detail.amount))}}</strong>
                </CCol>
                <!--                ********************88-->
                <CCol col="4" style="text-align: end">
                  <strong >{{$t('referenceNo')}} : </strong>
                </CCol>
                <CCol col="8" style="text-align: start">

                  <strong >{{doc_detail.masterCode}}</strong>
                </CCol>
                <!--                ********************88-->

              </CRow>

            </CCardHeader>
            <CCardBody>

              <CRow>

                <CCol col="12">
                  <strong>{{$t('tables.summary')}}: {{ doc_detail.payDesc }}</strong>
                </CCol>
              </CRow>



            </CCardBody>
          </CCard>

      </CCol>
    </CRow>
    <CModal
        :title="$t('requestDetail')"
        color="dark"
        size="lg"
        :show.sync="pre_finalize"
    >
      <CRow>
        <CCol col="4"><label>{{$t('docNumber')}}: 1</label></CCol>
        <CCol col="4"><label>{{$t('documentDoc')}}</label></CCol>
        <CCol col="4"><label>{{$t('docDate')}}</label></CCol>
      </CRow>
      <CRow>
        <CCol col="4"><label>{{$t('docDescription')}}:</label></CCol>
        <CCol col="4"><label></label></CCol>
        <CCol col="4"><label>Page 1</label></CCol>
      </CRow>

      <template #footer>
        <CButton @click="pre_finalize = false,finalize()" color="danger">{{$t('buttons.ok')}}</CButton>
        <CButton @click="pre_finalize = false" color="danger">{{$t('buttons.cancel')}}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
  ],
  styles: [
    'https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css',
    'https://omdesho.ir/print_css/printing.css',

  ]
}

Vue.use(VueHtmlToPaper, options);
var items_data = [];


export default {
  name: 'Login',
  props:{
    doc_id:Number,
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      VUE_APP_Currency: localStorage.getItem('currency'),
      VUE_APP_NAME: localStorage.getItem('app_name'),
      date: '',
      pre_finalize:false,
      product_items: items_data.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%;padding:0px'},
        {key: 'accountName', label: this.$t('accountSarfasl'), _style: 'width:20%;padding:0px'},
        // {key: 'accountCode', label: this.$t('components.groupCode'), _style: 'width:5%;padding:0px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'tafsiliTitle', label: this.$t('tafsiliAccount'), _style: 'width:20%;padding:0px'},
        // {key: 'joz', label: this.$t('subAmount'), _style: 'width:10%;padding:0px'},

        {key: 'debtor', label: this.$t('bedehkar'), _style: 'width:10%;padding:0px'},
        {key: 'creditor', label: this.$t('bestankar'), _style: 'width:10%;padding:0px'},
        // {key: 'takhfif', label: this.$t('tables.off'), _style: 'padding:0px'},
        // {key: 'tax', label: this.$t('tables.tax'), _style: 'padding:0px'},
        // {key: 'summary', label: this.$t('tables.summary'), _style: 'padding:0px'},
      ],


      pre_finalize_items: [{
        tafzili:"9",
        moein:"8",
        kol:"12",
        account:"پرداخت هزینه سوخت",
        price_joz:"120000",

        price_bedehkar:"1000",
        price_bestankar:"1000"},{
        tafzili:"",
        moein:"",
        kol:"",
        account:"",
        price_joz:this.$t('totalDoc'),
        price_bedehkar:"1000",
        price_bestankar:"1000"}],
      pre_finalize_fields: [
        {key: 'tafzili', label: this.$t('tafsili'), _style: 'width:3%;padding:0px'},
        {key: 'moein', label: this.$t('moein'), _style: 'width:3%;padding:0px'},
        {key: 'kol', label: this.$t('total'), _style: 'width:3%;padding:0px'},
        {key: 'account', label:this.$t('components.groupName'), _style: 'width:10%;padding:0px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'padding:0px'},
        {key: 'price_joz', label: this.$t('subAmount'), _style: 'width:5%;padding:0px'},
        {key: 'price_bedehkar', label: this.$t('bedehkar'), _style: 'width:5%;padding:0px'},
        {key: 'price_bestankar', label:this.$t('bestankar'), _style: 'width:5%;padding:0px'},

      ],
      fields_total_price: [
        {key: 'resultTitle', label: this.$t('tables.name'), _style: 'padding:5px;display:none'},
        {key: 'resultPrice', label: this.$t('tables.price'), _style: 'padding:5px;display:none'},

      ],

      selectedTypeQty: 1,
      selectedTypeLabel: this.$t('components.seller'),
      selectedTypeLabelRevert: this.$t('buttons.buyer'),
      selectedTypeTitle: this.$t('components.documentBuy'),
      selectedType: 1,
      tablo: '',
      address: '',

      vMobile: '',
      partyMobile: '',
      tozikonandeMobile: '',

      document_person: '',
      document_person_id: '',
      document_summary: '',
      document_visitor: '',
      document_driver: '',
      doc_detail: {},


      product_name: '',
      product_count: '',
      product_unit: '',
      product_summary: '',
      product_price: '',

      unit_items: [],
      doc_status: 0,
      // total_price: 0,
      details: [],
      permission_group_items: [],
      selected_permission_group: 0,

      places_items: [],
      unit_items_filtered: [],
      selected_place: '',
      selected_product: null,

      status_form: 0,
      master_id: 0,
      document_result_price: [],

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    // this.get_document_master();


    bus.$on('delete_confirm_factor'+this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  created() {

  },
  watch: {
    'doc_id': function () {
      this.get_document_master();
    },
    // 'product_items': function () {
    //   this.total_price = 0;
    //
    //   var unit_value = 1;
    //   this.total_price = 0;
    //   this.product_items.forEach((val) => {
    //     this.unit_items.forEach((val_unit) => {
    //       if (val_unit.id == val.productUnitId) {
    //         unit_value = val_unit.value;
    //       }
    //
    //     });
    //     val.total_price = (Math.abs(val.qty) * val.price * unit_value);
    //     this.total_price += (Math.abs(val.qty) * val.price * unit_value);
    //
    //   });
    //   this.total_price = this.total_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // },
    'selectedType': function () {
      if (this.selectedType == 1) {

        this.selectedTypeLabel = this.$t('components.seller');
        this.selectedTypeLabelRevert = this.$t('components.buyer');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentBuy');
      }
      if (this.selectedType == 3) {
        this.selectedTypeLabel = this.$t('components.buyer');
        this.selectedTypeLabelRevert = this.$t('components.seller');
        this.selectedTypeQty = -1;
        this.selectedTypeTitle = this.$t('components.documentSell');

      }
      if (this.selectedType == 5) {
        this.selectedTypeLabel = this.$t('components.employee');
        this.selectedTypeLabelRevert = this.$t('components.company');
        this.selectedTypeQty = 1;
        this.selectedTypeTitle = this.$t('components.documentFirst');

      }
    },
  },
  methods: {
    finalize() {
      var self = this;


      const formData = new FormData();

      var url = "AddAccountDocFinal";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.$root.modal_component.show_api_response_modals(response);

        if (content_data.statusCode == 0) {
          self.get_document_master();

        } else {
          // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },


    print() {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    goEdit() {
      // Pass the element id here
      this.$router.push({path: "/dashboard/documents/edit-document/" + this.doc_id});
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_document_master() {
      var self = this;
if(this.doc_id==null){
  return false
}

      const formData = new FormData();

      var url = "GetCashPaymentInfo";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
//     self.items_buy = content_data.data.map((item, row_id) => {
// // if(item.isCustomer){
//     return {...item, row_id}
          self.doc_detail = response.data.data
          var total_debtor = 0;
          var total_creditor = 0;
          self.doc_detail.details.forEach((val) => {
            total_debtor+=val.debtor;
            total_creditor+=val.creditor;

              });
          self.doc_detail.details.push({accountName:'',tafsiliTitle:self.$t('totalDoc'),debtor:total_debtor,creditor:total_creditor,});

        } else {
          // self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_result() {
      var self = this;


      const formData = new FormData();

      var url = "GetFactorResultByMasterId";

      formData.append("Id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.document_result_price = content_data.data;
          self.get_user_data();

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_document_details() {
      var self = this;


      const formData = new FormData();

      var url = "GetDocItemsByDocId";

      formData.append("id", this.doc_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.product_items = content_data.data.map((item, row_id) => {
            return {...item, row_id}

          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog() {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_factor'+this.confirm_delete_name);

      // this.status_form = this.masterFactorId;

    },
    get_user_data() {

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetPersonById";

      formData.append('id', this.document_person_id);


      axios.post(url, formData, {}).then((res) => {

        var person  = res.data.data.person;
        self.document_person = person.personName +" "+ person.surName +" "+ person.mobileNo
        // self.document_person_remain_amount = res.data.data.mande;
        var tota_price = self.document_result_price[self.document_result_price.length-1].resultPrice;
        tota_price = tota_price.replaceAll(",","");

        // var  obj = {resultTitle: "مانده از قبل", resultPrice: res.data.data.mande.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")};
      tota_price =   parseInt(res.data.data.mande)+parseInt(tota_price)

        // self.document_result_price.push(obj)
        // obj = {resultTitle: "مبلغ نهایی", resultPrice:tota_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") };
        // self.document_result_price.push(obj)


      })
          .catch(function (error) {

            console.log(error);
          });


    },

    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteFactorMaster";


      formData.append('id', this.doc_id);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        // self.get_lists();
        //  this.$router.push({ path: '/dashboard/documents/daily-list/0'});
        self.$router.go(-1)

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    }

  }
}

</script>
